import type { PlanList_DesignPageQuery } from "@/lib/gql/__generated__/graphql";

type Props = {
	serverModel: PlanList_DesignPageQuery;
};

export const useInitialized = ({ serverModel }: Props) => {
	return {
		data: serverModel,
	};
};
